import { Select } from "antd";
import React from "react";
import styled from "styled-components";

import { academicYears, defaultAcademicYear } from "years";

import arrowDown from "assets/images/png/arrow_down.png";

const YearSelect = ({ onChange, item, minBeYear }) => {
  const handleChange = (value) => {
    localStorage.setItem("year", value);
    onChange && onChange(value);
  };
  const yearOptions =
    item ||
    academicYears
      .filter(({ be }) => !minBeYear || Number(be) >= Number(minBeYear))
      .map(({ ce, label }) => ({
        value: ce,
        label,
      }));
  const defaultValue = yearOptions.some(
    ({ value }) => value === localStorage.getItem("year")
  )
    ? localStorage.getItem("year")
    : yearOptions[0]?.value || defaultAcademicYear.ce;

  return (
    <CustomSelect
      defaultValue={defaultValue}
      dropdownAlign={{ offset: [50, 0] }}
      getPopupContainer={(node) => node.parentNode}
      dropdownMatchSelectWidth={false}
      suffixIcon={<img src={arrowDown} alt="" />}
      options={yearOptions}
      onChange={handleChange}
      placeholder="เลือกดูตามปีที่เข้าศึกษา"
      listHeight={165}
    />
  );
};

export default YearSelect;

const CustomSelect = styled(Select)`
  width: 417px;
  height: 74px;

  .ant-select-selector {
    border: 1px solid var(--secondary) !important;
    height: 74px !important;
    border-radius: 37px !important;
    font-family: "Noto Sans Thai" !important;
    font-size: 26px !important;
    font-weight: 700 !important;
    color: var(--black) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 30px !important;
    background-color: #fff9ea !important;
    opacity: 85%;

    &:hover {
      color: var(--white);
    }
  }

  .ant-select-arrow {
    right: 24px !important;

    img {
      width: 24px;
      height: 14px;
    }
  }

  @media screen and (max-width: 414px) {
    height: 58px !important;

    .ant-select-selector {
      height: 58px !important;
      font-size: 20px !important;
    }

    .ant-select-item {
      font-size: 20px !important;
    }
  }

  @media screen and (min-width: 414px) and (max-width: 896px) and (orientation: landscape) {
    height: 48px !important;

    .ant-select-selector {
      height: 48px !important;
      font-size: 16px !important;
    }

    .ant-select-item {
      font-size: 16px !important;
    }
  }

  .ant-select-selection-placeholder {
    padding-right: 32px !important;
    color: var(--black) !important;
  }

  .ant-select-item {
    align-items: center;
    font-size: 26px !important;
    font-weight: 700 !important;
    min-height: 55px !important;
    padding: 0 !important;
    color: var(--black) !important;

    &:hover {
      color: var(--secondary) !important;
    }
  }

  .ant-select-selection-item {
    color: var(--black) !important;
    font-family: "Noto Sans Thai" !important;
    font-size: 26px !important;
    font-weight: 700 !important;
  }

  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: var(--primary) !important;
  }

  .ant-select-dropdown {
    width: 316px !important;
    min-width: 316px !important;
  }

  @media only screen and (max-width: 430px) {
    width: 317px;

    .ant-select-dropdown {
      width: 216px !important;
      min-width: 216px !important;
    }
  }

  @media only screen and (max-width: 414px) {
    width: 280px;

    .ant-select-dropdown {
      width: 180px !important;
      min-width: 180px !important;
    }
  }
`;
